import {
  HANDWRITTEN_CANVAS_PREVIEW_HEIGHT,
  HANDWRITTEN_CANVAS_PREVIEW_WIDTH,
} from "@/utils/Constant";
import { svgElementToPngFile } from "@/utils/helpers/image-helper";
import { toastError } from "@/utils/helpers/toast-helper";
import Signature, { SignatureRef } from "@uiw/react-signature";
import { FunctionComponent, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import BasicButton from "@components/core/buttons/BasicButton";
import BasicModal, {
  BasicModalProps,
} from "@components/core/modals/BasicModal";

interface HandwritteSignatureModalProps extends BasicModalProps {
  onSubmit: (file: File) => void;
}

const HandwritteSignatureModal: FunctionComponent<
  HandwritteSignatureModalProps
> = ({ onSubmit, onCancel, ...props }) => {
  const { t } = useTranslation();

  const svgRef = useRef<SignatureRef>(null);
  const [svgEncodedData, setSvgEncodedData] = useState<string>();

  const handleClear = () => {
    svgRef?.current?.clear();
    setSvgEncodedData(undefined);
  };

  const handleSubmit = (svg?: SVGSVGElement) => {
    if (svg) {
      svgElementToPngFile(svg, "handwrittenSignature.png")
        .then((pngFile: File) => {
          onSubmit(pngFile);
          onCancel();
        })
        .catch((error: string) => {
          toastError(`Erreur: ${t(error)}`);
          console.error(error);
        });
    }
  };

  const handleSignatureChange = () => {
    const svgElement = svgRef.current?.svg;
    if (!svgElement) {
      setSvgEncodedData(undefined);
      return;
    }

    const serializer = new XMLSerializer();
    const svgString = serializer.serializeToString(svgElement);
    const encodedData = `data:image/svg+xml;base64,${btoa(decodeURIComponent(encodeURIComponent(svgString)))}`;
    setSvgEncodedData(encodedData);
  };

  return (
    <BasicModal
      className="modal-lg"
      {...props}
      title={t("modals.info.signatureHandwrittenPicture.title")}
      onCancel={onCancel}
      onOk={() => {
        handleSubmit(svgRef.current?.svg ?? undefined);
        onCancel();
      }}
      buttonText={t("modal.save")}
    >
      <div className="container-gap-xl">
        <div className="dashed-container">
          <Signature
            ref={svgRef}
            height={HANDWRITTEN_CANVAS_PREVIEW_HEIGHT}
            width={HANDWRITTEN_CANVAS_PREVIEW_WIDTH}
            onPointer={handleSignatureChange}
          />
        </div>
        {svgEncodedData ? (
          <img src={svgEncodedData} className="large canvas" />
        ) : (
          <div className="large canvas"></div>
        )}

        <div className="button-container">
          <BasicButton onClick={handleClear} text={t("modal.clear")} />
        </div>
      </div>
    </BasicModal>
  );
};

export default HandwritteSignatureModal;
